import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super(`/api/rota-de-facilidade`);
  }
}

export default new Service();
